export default __webpack_public_path__ + "static/media/coding.287c99b3.jpg";